<template>
  <tr v-if="shouldShow" class="expand" :class="{ even: rowIndex % 2 === 0 }">
    <td class="animateIn" :colspan="columnCount">
      <slot />
    </td>
  </tr>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { ContentRow } from "@/components/controls/grid/BmGridData";

interface BmGridTableExpandableRowProps {
  row: ContentRow;
  rowIndex: number;
  columnCount: number;
  allowExpand: boolean;
  hasExpandSlot: boolean;
  rowExpandable: (item: any) => boolean;
}

const props = defineProps<BmGridTableExpandableRowProps>();

const shouldShow = computed(
  () =>
    props.allowExpand &&
    props.hasExpandSlot &&
    props.row.isExpanded &&
    props.rowExpandable(props.row)
);
</script>

<style scoped lang="sass">
tr.expand
  background-color: transparent
  height: 36px

td
  border-bottom: 1px solid #D1CFD7

@keyframes slideIn
  0%
    opacity: 0
    transform: translateY(-20px)

  100%
    opacity: 1
    transform: translateY(0)

.animateIn
  overflow: hidden
  animation: slideIn .3s ease-out
  transition: height .3s ease-out

:deep(.animateIn tbody)
  overflow: hidden
  animation: slideIn .4s ease-out
</style>
